import { Toast as ToastRadix } from "radix-ui";

interface ToastProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  type?: 'success' | 'error' | 'warning' | 'info';
  /** ms; omit to use provider default */
  duration?: number;
}

export const Toast = ({ 
  open, 
  onOpenChange, 
  title, 
  description, 
  type = 'success',
  duration,
}: ToastProps) => {
  return (
    <ToastRadix.Root 
      className="toast-root" 
      open={open} 
      onOpenChange={onOpenChange}
      data-variant={type}
      {...(duration != null ? { duration } : {})}
    >
      <ToastRadix.Title className="toast-title">{title}</ToastRadix.Title>
      {description && (
        <ToastRadix.Description className="toast-description">
          {description}
        </ToastRadix.Description>
      )}
    </ToastRadix.Root>
  );
};

export const ToastViewport = () => {
  return <ToastRadix.Viewport className="toast-viewport" />;
};

export default Toast;
